module.exports = __webpack_public_path__ + "img/Cards.fa1537b5.png";